import {
  mapTruckGroupsResponse,
  type TruckGroup,
  mapTruckGroupResponse,
} from "../types/truckGroup";
import api from "./axios";
import type { PaginationParam } from "../types/paginationResponse";
import { buildPaginationQuery } from "../utils/pagination";

export interface TruckGroupResponse {
  data: {
    truckGroup: TruckGroup;
  };
}

export interface TruckGroupsResponse {
  data: {
    truckGroups: TruckGroup[];
  };
}

export interface CreateTruckGroupPayload {
  name: string;
  truckIds: string[];
  editorUserIds: string[];
}

export interface UpdateTruckGroupPayload extends CreateTruckGroupPayload {}

export const getTruckGroupsApi = async (): Promise<TruckGroup[]> => {
  try {
    const response = await api.get<any>("/api/v1/truckGroups?scope=company");
    return mapTruckGroupsResponse(response.data);
  } catch (error) {
    console.error("Error fetching truck groups:", error);
    throw error;
  }
};

export const createTruckGroupApi = async (data: CreateTruckGroupPayload): Promise<TruckGroup> => {
  try {
    const response = await api.post<TruckGroupResponse>("/api/v1/truckGroups", data);
    return mapTruckGroupResponse(response.data.data);
  } catch (error: any) {
    console.error("Error creating truck group:", error.response?.data || error);
    throw error;
  }
};

export const getTrucksByGroupIdApi = async (groupId: string, pagination?: PaginationParam) => {
  try {
    const params = new URLSearchParams();
    params.append("truckGroupId", groupId);
    const paginationQuery = buildPaginationQuery(pagination);
    const baseQuery = paginationQuery ? paginationQuery.replace("?", "&") : "";
    const url = `/api/v1/trucks/search?truckGroupId=${groupId}${baseQuery}`;
    const response = await api.get(url);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching trucks by group ID:", error);
    throw error;
  }
};

export const updateTruckGroupApi = async (
  id: string,
  data: UpdateTruckGroupPayload,
): Promise<TruckGroup> => {
  try {
    const response = await api.put<TruckGroupResponse>(`/api/v1/truckGroups/${id}`, data);
    return mapTruckGroupResponse(response.data.data.truckGroup);
  } catch (error) {
    console.error("Error updating truck group:", error);
    throw error;
  }
};

export const deleteTruckGroupApi = async (id: string): Promise<void> => {
  try {
    await api.delete(`/api/v1/truckGroups/${id}`);
  } catch (error) {
    console.error("Error deleting truck group:", error);
    throw error;
  }
};
